import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NewVouch from "./pages/NewVouch";
import AnimatedBackground from "./components/AnimatedBackground";
import "./index.css";

function App() {
  return (
    <div className="app-root">
      <AnimatedBackground />
      <Router>
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bewertung-geben" element={<NewVouch />} />
          </Routes>
        </main>
      </Router>
    </div>
  );
}

export default App;
